import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PracticeService {

  constructor() { }

  async createPracticeSession(username:string, practiceTemplateId:number):Promise<number> {
    return 1;
  }
}
